module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706121922-6a92b31330-master/~/core-js/modules/_html.js
// module id = 167
// module chunks = 1